import React, { Suspense, useMemo } from 'react'
import { lazyWithRetry } from '@rst/libs-ts'
import { useStore } from 'effector-react'

import { MainBlockType } from '../lib/types'
import { RenderBlock } from '../../../../../types'
import { mainCtx } from '../../../ctx'
import { useMainBlockType } from '../lib/use-main-block-type'
import { BlockPreload } from '../../../../common/block-preload'

const MobileDefaultMainBlock = lazyWithRetry(
	() => import('../organisms/default-main-block/default-mobile')
)
const DeviceMainBlock = lazyWithRetry(
	() => import('../organisms/device-main-block')
)
const MobileHalfMainBlock = lazyWithRetry(
	() => import('../organisms/half-main-block/half-mobile')
)
const SimpleMainBlock = lazyWithRetry(
	() => import('../organisms/simple-main-block')
)

const MainMobile = () => {
	const data = useStore(mainCtx.useCtx().$main)

	return <MainMobileCore data={data} />
}

const MainMobileCore = ({ data }: { data: RenderBlock.InitMain }) => {
	const type = useMainBlockType({
		type: data.type_block,
		settingType: data.setting_block?.type,
	})

	const renderBlock = useMemo(() => mainBlocks[type], [type])

	return <Suspense fallback={null}>{renderBlock(data)}</Suspense>
}

const mainBlocks: Record<
	MainBlockType,
	(data: RenderBlock.InitMain) => JSX.Element | null
> = {
	none: () => null,
	default: data => <MobileDefaultMainBlock data={data} />,
	device: data => <DeviceMainBlock data={data} />,
	half: data => <MobileHalfMainBlock data={data} />,
	simple: data => <SimpleMainBlock data={data} />,
}

export { MainMobile, MainMobileCore }
